import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import axios from "axios";
import {
  APIURL,
  IMAGE_FULL_URL,
  IMAGE_NOPHOTO_URL,
  IMAGE_LOADING,
  IMAGE_PDF_URL,
  IMAGE_UPLOAD_ERROR,
  PORT,
} from "../../config/config";

const ModalPayImage = ({
  isOpen,
  toggle,
  initialImages = {},
  loadDataCarSellPay,
  car_sell_pay,
}) => {
  const [payImages, setPayImages] = useState({
    pay_image1: initialImages.pay_image1 || IMAGE_NOPHOTO_URL,
    pay_image2: initialImages.pay_image2 || IMAGE_NOPHOTO_URL,
    pay_image3: initialImages.pay_image3 || IMAGE_NOPHOTO_URL,
    pay_image4: initialImages.pay_image4 || IMAGE_NOPHOTO_URL,
  });

  const imgRefs = {
    img_pay_image1: useRef(null),
    img_pay_image2: useRef(null),
    img_pay_image3: useRef(null),
    img_pay_image4: useRef(null),
  };

  useEffect(() => {
    // Update state if props change
    setPayImages({
      pay_image1: initialImages.pay_image1 || IMAGE_NOPHOTO_URL,
      pay_image2: initialImages.pay_image2 || IMAGE_NOPHOTO_URL,
      pay_image3: initialImages.pay_image3 || IMAGE_NOPHOTO_URL,
      pay_image4: initialImages.pay_image4 || IMAGE_NOPHOTO_URL,
    });
  }, [initialImages]);

  const handleClose = () => {
    loadDataCarSellPay();
    toggle();
  };

  const handleUpload = (e) => {
    const input_file_name = e.target.name;

    setPayImages((prevState) => ({
      ...prevState,
      [input_file_name]: IMAGE_LOADING,
    }));

    handleUploadPayImage(e, (image_url) => {
      setPayImages((prevState) => ({
        ...prevState,
        [input_file_name]: image_url,
      }));
    });
  };

  function handleUploadPayImage(event, callback) {
    // const car_sell_pay = this.state.car_sell_pay_selected;
    const input_file_name = event.target.name;
    let pay_key = "";

    const car_sell_pay_id = car_sell_pay.car_sell_pay_id;

    const data = new FormData();
    data.append("uploads", event.target.files[0], event.target.files[0].name);
    data.append("car_sell_pay_id", car_sell_pay_id);
    data.append("pay_key", pay_key);
    data.append("pay_image", input_file_name);

    // car_sell_pay/image
    axios
      .put(APIURL + "/car_sell_pay/image/" + car_sell_pay_id, data)
      .then(function (res) {
        const resData = res.data;
        const filename = resData.image;
        const pay_key = resData.pay_key;
        let image_url = "";

        if (resData.image === undefined) {
          image_url = IMAGE_UPLOAD_ERROR;
        } else if (resData.image === "uploaderror") {
          image_url = IMAGE_UPLOAD_ERROR;
        } else {
          image_url = filename;
        }

        // if (input_file_name === "pay_image1") {
        //   that.setState({
        //     pay_image1: image_url,
        //     pay_key1: pay_key,
        //   });
        // } else if (input_file_name === "pay_image2") {
        //   that.setState({
        //     pay_image2: image_url,
        //     pay_key2: pay_key,
        //   });
        // } else if (input_file_name === "pay_image3") {
        //   that.setState({
        //     pay_image3: image_url,
        //     pay_key3: pay_key,
        //   });
        // } else if (input_file_name === "pay_image4") {
        //   // initialImages.pay_image4 = image_url;
        //   that.setState({
        //     pay_image4: image_url,
        //     pay_key4: pay_key,
        //   });
        // }
        callback(image_url);
      });
  }

  function saveCarImage(e, urlImage) {
    e.preventDefault();
    let a = document.createElement("a");
    a.href = urlImage;
    a.target = "_blank";
    a.download = urlImage;
    a.click();
    a.remove();
    return false;
  }

  const styles = {
    fileInputWrapper: {
      position: "relative",
      overflow: "hidden",
      display: "inline-block",
    },
    btnFileInput: {
      border: "none",
      background: "none",
      padding: 0,
      margin: 0,
    },
    btnFileInputImage: {
      width: "200px",
      height: "auto",
      maxHeight: "200px",
      objectFit: "contain",
      border: "1px solid #ddd",
    },
    fileInput: {
      fontSize: "100px",
      position: "absolute",
      left: 0,
      top: 0,
      opacity: 0,
      cursor: "pointer",
      width: "100%",
      height: "100%",
    },
  };

  return (
    <Modal
      className="modal-lg modal-dialog"
      isOpen={isOpen}
      toggle={handleClose}
    >
      <ModalHeader toggle={handleClose}>
        <strong className="font-sm">แนบสลิป</strong>
      </ModalHeader>
      <ModalBody>
        <div className="row p-5">
          <div className="form-group col-1" />

          <div className="form-group col-5">
            <label htmlFor="name">
              1) แนบภาพสลิป 1 &nbsp;
              <a
                rel="noopener noreferrer"
                href={payImages.pay_image1}
                target="_blank"
                onClick={(e) => saveCarImage(e, payImages.pay_image1)}
                className={
                  payImages.pay_image1 === IMAGE_NOPHOTO_URL ? "hidden" : ""
                }
              >
                <span>Download</span>
              </a>
            </label>

            <div style={styles.fileInputWrapper}>
              <button style={styles.btnFileInput}>
                <img
                  src={payImages.pay_image1}
                  style={styles.btnFileInputImage}
                  ref={imgRefs.img_pay_image1}
                  alt="เอกสาร 1"
                />
              </button>
              <input
                style={styles.fileInput}
                type="file"
                name="pay_image1"
                onChange={handleUpload}
              />
            </div>
          </div>

          <div className="form-group col-5">
            <label htmlFor="name">
              2) แนบภาพสลิป 2 &nbsp;
              <a
                rel="noopener noreferrer"
                href={payImages.pay_image2}
                target="_blank"
                onClick={(e) => saveCarImage(e, payImages.pay_image2)}
                className={
                  payImages.pay_image2 === IMAGE_NOPHOTO_URL ? "hidden" : ""
                }
              >
                <span>Download</span>
              </a>
            </label>
            <div style={styles.fileInputWrapper}>
              <button style={styles.btnFileInput}>
                <img
                  src={payImages.pay_image2}
                  style={styles.btnFileInputImage}
                  ref={imgRefs.img_pay_image2}
                  alt="เอกสาร 2"
                />
              </button>
              <input
                style={styles.fileInput}
                type="file"
                name="pay_image2"
                onChange={handleUpload}
              />
            </div>
          </div>

          <div className="form-group col-1" />

          <div className="form-group col-1" />

          <div className="form-group col-5">
            <label htmlFor="name">
              3) แนบภาพสลิป 3 &nbsp;
              <a
                rel="noopener noreferrer"
                href={payImages.pay_image3}
                target="_blank"
                onClick={(e) => saveCarImage(e, payImages.pay_image3)}
                className={
                  payImages.pay_image3 === IMAGE_NOPHOTO_URL ? "hidden" : ""
                }
              >
                <span>Download</span>
              </a>
            </label>
            <div style={styles.fileInputWrapper}>
              <button style={styles.btnFileInput}>
                <img
                  src={payImages.pay_image3}
                  style={styles.btnFileInputImage}
                  ref={imgRefs.img_pay_image3}
                  alt="เอกสาร 3"
                />
              </button>
              <input
                style={styles.fileInput}
                type="file"
                name="pay_image3"
                onChange={handleUpload}
              />
            </div>
          </div>

          <div className="form-group col-5">
            <label htmlFor="name">
              4) แนบภาพสลิป 4 &nbsp;
              <a
                rel="noopener noreferrer"
                href={payImages.pay_image4}
                target="_blank"
                onClick={(e) => saveCarImage(e, payImages.pay_image4)}
                className={
                  payImages.pay_image4 === IMAGE_NOPHOTO_URL ? "hidden" : ""
                }
              >
                <span>Download</span>
              </a>
            </label>
            <div style={styles.fileInputWrapper}>
              <button style={styles.btnFileInput}>
                <img
                  src={payImages.pay_image4}
                  style={styles.btnFileInputImage}
                  ref={imgRefs.img_pay_image4}
                  alt="เอกสาร 4"
                />
              </button>
              <input
                style={styles.fileInput}
                type="file"
                name="pay_image4"
                onChange={handleUpload}
              />
            </div>
          </div>
          <div className="form-group col-1" />
        </div>
      </ModalBody>
      <ModalFooter>
        {/*<Button color="primary" onClick={()=>{
        }}>
           xxx
        </Button>*/}{" "}
        <Button color="secondary" onClick={handleClose}>
          เรียบร้อย
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalPayImage;
